import Vue from 'vue'
import DataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import App from './App.vue'

Vue.use(DataV)
Vue.use(ElementUI)
Vue.prototype.$http = axios

new Vue({
  render: h => h(App)
}).$mount('#app')
